import addMount from "../../core/addMount";
import OpeningHours from "./OpeningHours.entry";

addMount({ appName: "opening-hours", app: OpeningHours });
